var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client as apiClient } from './client';
export function getNodeTypes() {
    return __awaiter(this, void 0, void 0, function* () {
        return apiClient.get('/node-types');
    });
}
export function createNodeType(data) {
    return __awaiter(this, void 0, void 0, function* () {
        return apiClient.post('/node-types', data);
    });
}
export function updateNodeType(id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        return apiClient.patch(`/node-types/${id}`, data);
    });
}
export function deleteNodeType(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.delete(`/node-types/${id}`);
    });
}
export function restoreNodeType(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.patch(`/node-types/${id}/restore`);
    });
}
export function deleteNodeTypePermanently(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.delete(`/node-types/${id}/permanent`);
    });
}
